module.exports = __webpack_public_path__ + "img/14.dc2cc65d.jpg";